'use strict';

/**
 * @abstract
 */
bbw.model.BasePostManager = Class({

    $inject: ['rpcClient', 'modelFactory', '$q', '$timeout'],

    _rpcClient: undefined,
    _modelFactory: undefined,
    $q: undefined,
    $timeout: undefined,

    _isInitialized: false,
    _isLoading: false,

    subtype: undefined,
    subtypes: undefined,

    perPage: undefined,
    commentPerPage: undefined,
    maxCommentPerPage: undefined,

    _scope: undefined,
    _scopePath: undefined,
    _page: undefined,

    _wasLoaded: false,

    _moreHandler: undefined,

    _commentsCache: undefined,
    _commentsRevOrder: false,

    construct: function(rpcClient, modelFactory, $q, $timeout) {
        this._rpcClient = rpcClient;
        this._modelFactory = modelFactory;
        this.$q = $q;
        this.$timeout = $timeout;
        this._commentsCache = {};
        this._page = 1;
        this.subtype = null;
        this._init();
    },

    $subtype: function(value) { // for select/ngOptions/ngModelOptions.getterSetter workaround
        if (angular.isUndefined(value)) {
            return this.subtype || null;
        } else {
            this.subtype = value || null;
        }
    },

    _init: function() {
        Class.abstractMethod();
    },

    setCommentsRevOrder: function(revOrder) {
        this._commentsRevOrder = !!revOrder;
        return this;
    },

    wireScope: function(scope, path, onPageChangeFn) {
        this._scope = scope;
        this._scopePath = path;
        this.moreHandler = this.getMoreHandler();
        scope[path] = this;

        this._wireEntityScope(scope, path);

        var pageChangeWatchExpr = this._getPageChangeWatchExpr();
        if (pageChangeWatchExpr && angular.isFunction(onPageChangeFn)) {
            this._scope.$watch(
                [path, pageChangeWatchExpr].join('.'),
                this._onPageChange.bind(this, onPageChangeFn)
            );
        }
        return this;
    },

    getScopePost: function() {
        return undefined;
    },

    _wireEntityScope: function(scope, path) {
        Class.abstractMethod();
    },

    _getPageChangeWatchExpr: function() {
        Class.abstractMethod();
    },

    _getPerPage: function() {
        return this.perPage || this.commentPerPage;
    },

    _onPageChange: function(onPageChangeFn, newValue, oldValue) {
        if (newValue != oldValue) {
            var page = parseInt(Math.ceil(newValue / this._getPerPage()));
            if (!isNaN(page) && page != this._page) {
                onPageChangeFn(this._page = page);
            }
        }
    },

    hasMore: function() {
        Class.abstractMethod();
    },

    isLoading: function() {
        return this._isLoading;
    },

    loadMore: function() {
        Class.abstractMethod();
    },

    _resolvePost: function(post) {
        post = post || this.getScopePost();
        if (!post) {
            throw new Error("Post is undefined");
        }
        return post;
    },

    _getCommentsCollectionIfLoaded: function(post) {
        return this._commentsCache[this._getCommentsCacheKey(post)] || null;
    },

    _getCommentsCacheKey: function(post) {
        return '' + this._resolvePost(post).get('id');
    },

    hasCommentsLoaded: function(post) {
        return angular.isDefined(this._commentsCache[this._getCommentsCacheKey(post)])
            && this._commentsCache[this._getCommentsCacheKey(post)].wasLoaded();
    },

    getCommentCollection: function(post, autoload) {
        post = this._resolvePost(post);
        var key = this._getCommentsCacheKey(post);

        if (angular.isUndefined(this._commentsCache[key])) {
            var commentCollection = this._modelFactory.create(bbw.model.CommentCollection);
            commentCollection.configure(
                post.get('id'),
                post.get('comments_count'),
                this._commentsRevOrder,
                this.commentPerPage,
                this.maxCommentPerPage,
                post.get('is_tracked_unread')
            );
            post.wireCommentsScope(commentCollection);
            this._commentsCache[key] = commentCollection;
        }

        var result = this._commentsCache[key];
        var updatePostTotalCount = function() {
            if (result.wasLoaded()) {
                var totalCount = result.getTotalCount();
                if (angular.isDefined(totalCount)) {
                    post.merge({comments_count: totalCount});
                }
            }
            return result;
        };
        if (autoload) {
            return result.ensureIsLoaded().then(updatePostTotalCount);
        } else {
            updatePostTotalCount();
            return this.$q.when(result);
        }
    },

    unsetCommentCollection: function(post) {
        var key = this._getCommentsCacheKey(post);

        if (angular.isDefined(this._commentsCache[key])) {
            this._commentsCache[key].empty();
            delete this._commentsCache[key];
        }
    },

    getMoreHandler: function() {
        if (angular.isUndefined(this._moreHandler)) {
            this._moreHandler = new (bbw.service.ScrollBottomHandler.extend({
                hasMore: this.hasMore.bind(this),
                isLoading: this.isLoading.bind(this),
                canMore: this.canMore.bind(this),
                loadMore: this.loadMore.bind(this)
            }));
        }
        return this._moreHandler;
    },

    canMore: function() {
        return true;
    },

    _updateComment: function(existingPost, comment) {
        var commentId = comment.get('id');
        var comments = existingPost._data.comments;
        if (comments && comments.$model && comments.$model.get(commentId)) {
            comments.$model.set(commentId, comment);
        }
    },

    init: function() {
        if (this._isInitialized) {
            return this.$q.when();
        } else {
            return this._doInit();
        }
    },

    _doInit: function() {
        Class.abstractMethod();
    },

    wasLoaded: function() {
        return this._wasLoaded;
    },

    deletePost: function(post) {
        post = this._resolvePost(post);
        return post.delete();
    }

});
